var $IwcIq$reactariafocus = require("@react-aria/focus");
var $IwcIq$reactariautils = require("@react-aria/utils");
var $IwcIq$react = require("react");
var $IwcIq$reactarialabel = require("@react-aria/label");
var $IwcIq$reactariainteractions = require("@react-aria/interactions");
var $IwcIq$reactariai18n = require("@react-aria/i18n");
var $IwcIq$internationalizeddate = require("@internationalized/date");
var $IwcIq$internationalizednumber = require("@internationalized/number");
var $IwcIq$reactariaspinbutton = require("@react-aria/spinbutton");
var $IwcIq$internationalizedstring = require("@internationalized/string");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "useDatePicker", () => $e90ae7c26a69c6b1$export$42df105a73306d51);
$parcel$export(module.exports, "useDateSegment", () => $5c015c6316d1904d$export$1315d136e6f7581);
$parcel$export(module.exports, "useDateField", () => $4acc2f407c169e55$export$5591b0b878c1a989);
$parcel$export(module.exports, "useTimeField", () => $4acc2f407c169e55$export$4c842f6a241dc825);
$parcel$export(module.exports, "useDateRangePicker", () => $20f695b1b69e6b9e$export$12fd5f0e9f4bb192);
$parcel$export(module.exports, "useDisplayNames", () => $934ac650a0aceb4b$export$d42c60378c8168f8);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

var $c1905b78f6d2f5bf$exports = {};
var $aa344be62785b256$exports = {};
$aa344be62785b256$exports = {
  "calendar": "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
  "day": "\u064A\u0648\u0645",
  "dayPeriod": "\u0635/\u0645",
  "endDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
  "era": "\u0627\u0644\u0639\u0635\u0631",
  "hour": "\u0627\u0644\u0633\u0627\u0639\u0627\u062A",
  "minute": "\u0627\u0644\u062F\u0642\u0627\u0626\u0642",
  "month": "\u0627\u0644\u0634\u0647\u0631",
  "second": "\u0627\u0644\u062B\u0648\u0627\u0646\u064A",
  "selectedDateDescription": args => "\u062A\u0627\u0631\u064A\u062E \u0645\u062D\u062F\u062F: ".concat(args.date),
  "selectedRangeDescription": args => "\u0627\u0644\u0645\u062F\u0649 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.startDate, " \u0625\u0644\u0649 ").concat(args.endDate),
  "selectedTimeDescription": args => "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.time),
  "startDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621",
  "timeZoneName": "\u0627\u0644\u062A\u0648\u0642\u064A\u062A",
  "weekday": "\u0627\u0644\u064A\u0648\u0645",
  "year": "\u0627\u0644\u0633\u0646\u0629"
};
var $615986c3475e7c8c$exports = {};
$615986c3475e7c8c$exports = {
  "calendar": "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440",
  "day": "\u0434\u0435\u043D",
  "dayPeriod": "\u043F\u0440.\u043E\u0431./\u0441\u043B.\u043E\u0431.",
  "endDate": "\u041A\u0440\u0430\u0439\u043D\u0430 \u0434\u0430\u0442\u0430",
  "era": "\u0435\u0440\u0430",
  "hour": "\u0447\u0430\u0441",
  "minute": "\u043C\u0438\u043D\u0443\u0442\u0430",
  "month": "\u043C\u0435\u0441\u0435\u0446",
  "second": "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
  "selectedDateDescription": args => "\u0418\u0437\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date),
  "selectedRangeDescription": args => "\u0418\u0437\u0431\u0440\u0430\u043D \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.startDate, " \u0434\u043E ").concat(args.endDate),
  "selectedTimeDescription": args => "\u0418\u0437\u0431\u0440\u0430\u043D\u043E \u0432\u0440\u0435\u043C\u0435: ".concat(args.time),
  "startDate": "\u041D\u0430\u0447\u0430\u043B\u043D\u0430 \u0434\u0430\u0442\u0430",
  "timeZoneName": "\u0447\u0430\u0441\u043E\u0432\u0430 \u0437\u043E\u043D\u0430",
  "weekday": "\u0434\u0435\u043D \u043E\u0442 \u0441\u0435\u0434\u043C\u0438\u0446\u0430\u0442\u0430",
  "year": "\u0433\u043E\u0434\u0438\u043D\u0430"
};
var $6c6207692f1ab248$exports = {};
$6c6207692f1ab248$exports = {
  "calendar": "Kalend\xE1\u0159",
  "day": "den",
  "dayPeriod": "\u010D\xE1st dne",
  "endDate": "Kone\u010Dn\xE9 datum",
  "era": "letopo\u010Det",
  "hour": "hodina",
  "minute": "minuta",
  "month": "m\u011Bs\xEDc",
  "second": "sekunda",
  "selectedDateDescription": args => "Vybran\xE9 datum: ".concat(args.date),
  "selectedRangeDescription": args => "Vybran\xE9 obdob\xED: ".concat(args.startDate, " a\u017E ").concat(args.endDate),
  "selectedTimeDescription": args => "Vybran\xFD \u010Das: ".concat(args.time),
  "startDate": "Po\u010D\xE1te\u010Dn\xED datum",
  "timeZoneName": "\u010Dasov\xE9 p\xE1smo",
  "weekday": "den v t\xFDdnu",
  "year": "rok"
};
var $fb37a9d024dd70f8$exports = {};
$fb37a9d024dd70f8$exports = {
  "calendar": "Kalender",
  "day": "dag",
  "dayPeriod": "AM/PM",
  "endDate": "Slutdato",
  "era": "\xE6ra",
  "hour": "time",
  "minute": "minut",
  "month": "m\xE5ned",
  "second": "sekund",
  "selectedDateDescription": args => "Valgt dato: ".concat(args.date),
  "selectedRangeDescription": args => "Valgt interval: ".concat(args.startDate, " til ").concat(args.endDate),
  "selectedTimeDescription": args => "Valgt tidspunkt: ".concat(args.time),
  "startDate": "Startdato",
  "timeZoneName": "tidszone",
  "weekday": "ugedag",
  "year": "\xE5r"
};
var $d7780bd4790f7ae9$exports = {};
$d7780bd4790f7ae9$exports = {
  "calendar": "Kalender",
  "day": "Tag",
  "dayPeriod": "Tagesh\xE4lfte",
  "endDate": "Enddatum",
  "era": "Epoche",
  "hour": "Stunde",
  "minute": "Minute",
  "month": "Monat",
  "second": "Sekunde",
  "selectedDateDescription": args => "Ausgew\xE4hltes Datum: ".concat(args.date),
  "selectedRangeDescription": args => "Ausgew\xE4hlter Bereich: ".concat(args.startDate, " bis ").concat(args.endDate),
  "selectedTimeDescription": args => "Ausgew\xE4hlte Zeit: ".concat(args.time),
  "startDate": "Anfangsdatum",
  "timeZoneName": "Zeitzone",
  "weekday": "Wochentag",
  "year": "Jahr"
};
var $9cdf03311f06c4ac$exports = {};
$9cdf03311f06c4ac$exports = {
  "calendar": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF",
  "day": "\u03B7\u03BC\u03AD\u03C1\u03B1",
  "dayPeriod": "\u03C0.\u03BC./\u03BC.\u03BC.",
  "endDate": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
  "era": "\u03C0\u03B5\u03C1\u03AF\u03BF\u03B4\u03BF\u03C2",
  "hour": "\u03CE\u03C1\u03B1",
  "minute": "\u03BB\u03B5\u03C0\u03C4\u03CC",
  "month": "\u03BC\u03AE\u03BD\u03B1\u03C2",
  "second": "\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
  "selectedDateDescription": args => "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1: ".concat(args.date),
  "selectedRangeDescription": args => "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03B5\u03CD\u03C1\u03BF\u03C2: ".concat(args.startDate, " \u03AD\u03C9\u03C2 ").concat(args.endDate),
  "selectedTimeDescription": args => "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03CE\u03C1\u03B1: ".concat(args.time),
  "startDate": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2",
  "timeZoneName": "\u03B6\u03CE\u03BD\u03B7 \u03CE\u03C1\u03B1\u03C2",
  "weekday": "\u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03AE",
  "year": "\u03AD\u03C4\u03BF\u03C2"
};
var $f93fc9e164ae811c$exports = {};
$f93fc9e164ae811c$exports = {
  "era": "era",
  "year": "year",
  "month": "month",
  "day": "day",
  "hour": "hour",
  "minute": "minute",
  "second": "second",
  "dayPeriod": "AM/PM",
  "calendar": "Calendar",
  "startDate": "Start Date",
  "endDate": "End Date",
  "weekday": "day of the week",
  "timeZoneName": "time zone",
  "selectedDateDescription": args => "Selected Date: ".concat(args.date),
  "selectedRangeDescription": args => "Selected Range: ".concat(args.startDate, " to ").concat(args.endDate),
  "selectedTimeDescription": args => "Selected Time: ".concat(args.time)
};
var $7426c3264bf5ffea$exports = {};
$7426c3264bf5ffea$exports = {
  "calendar": "Calendario",
  "day": "d\xEDa",
  "dayPeriod": "a.\xA0m./p.\xA0m.",
  "endDate": "Fecha final",
  "era": "era",
  "hour": "hora",
  "minute": "minuto",
  "month": "mes",
  "second": "segundo",
  "selectedDateDescription": args => "Fecha seleccionada: ".concat(args.date),
  "selectedRangeDescription": args => "Rango seleccionado: ".concat(args.startDate, " a ").concat(args.endDate),
  "selectedTimeDescription": args => "Hora seleccionada: ".concat(args.time),
  "startDate": "Fecha de inicio",
  "timeZoneName": "zona horaria",
  "weekday": "d\xEDa de la semana",
  "year": "a\xF1o"
};
var $1115cc0042de790c$exports = {};
$1115cc0042de790c$exports = {
  "calendar": "Kalender",
  "day": "p\xE4ev",
  "dayPeriod": "enne/p\xE4rast l\xF5unat",
  "endDate": "L\xF5ppkuup\xE4ev",
  "era": "ajastu",
  "hour": "tund",
  "minute": "minut",
  "month": "kuu",
  "second": "sekund",
  "selectedDateDescription": args => "Valitud kuup\xE4ev: ".concat(args.date),
  "selectedRangeDescription": args => "Valitud vahemik: ".concat(args.startDate, " kuni ").concat(args.endDate),
  "selectedTimeDescription": args => "Valitud aeg: ".concat(args.time),
  "startDate": "Alguskuup\xE4ev",
  "timeZoneName": "ajav\xF6\xF6nd",
  "weekday": "n\xE4dalap\xE4ev",
  "year": "aasta"
};
var $4e80389dccb9283f$exports = {};
$4e80389dccb9283f$exports = {
  "calendar": "Kalenteri",
  "day": "p\xE4iv\xE4",
  "dayPeriod": "vuorokaudenaika",
  "endDate": "P\xE4\xE4ttymisp\xE4iv\xE4",
  "era": "aikakausi",
  "hour": "tunti",
  "minute": "minuutti",
  "month": "kuukausi",
  "second": "sekunti",
  "selectedDateDescription": args => "Valittu p\xE4iv\xE4m\xE4\xE4r\xE4: ".concat(args.date),
  "selectedRangeDescription": args => "Valittu aikav\xE4li: ".concat(args.startDate, " \u2013 ").concat(args.endDate),
  "selectedTimeDescription": args => "Valittu aika: ".concat(args.time),
  "startDate": "Alkamisp\xE4iv\xE4",
  "timeZoneName": "aikavy\xF6hyke",
  "weekday": "viikonp\xE4iv\xE4",
  "year": "vuosi"
};
var $78ad6f738c1f38d1$exports = {};
$78ad6f738c1f38d1$exports = {
  "calendar": "Calendrier",
  "day": "jour",
  "dayPeriod": "cadran",
  "endDate": "Date de fin",
  "era": "\xE8re",
  "hour": "heure",
  "minute": "minute",
  "month": "mois",
  "second": "seconde",
  "selectedDateDescription": args => "Date s\xE9lectionn\xE9e\xA0: ".concat(args.date),
  "selectedRangeDescription": args => "Plage s\xE9lectionn\xE9e\xA0: ".concat(args.startDate, " au ").concat(args.endDate),
  "selectedTimeDescription": args => "Heure choisie\xA0: ".concat(args.time),
  "startDate": "Date de d\xE9but",
  "timeZoneName": "fuseau horaire",
  "weekday": "jour de la semaine",
  "year": "ann\xE9e"
};
var $50fa4716d827cd97$exports = {};
$50fa4716d827cd97$exports = {
  "calendar": "\u05DC\u05D5\u05D7 \u05E9\u05E0\u05D4",
  "day": "\u05D9\u05D5\u05DD",
  "dayPeriod": "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6/\u05D0\u05D7\u05D4\u05F4\u05E6",
  "endDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E1\u05D9\u05D5\u05DD",
  "era": "\u05EA\u05E7\u05D5\u05E4\u05D4",
  "hour": "\u05E9\u05E2\u05D4",
  "minute": "\u05D3\u05E7\u05D4",
  "month": "\u05D7\u05D5\u05D3\u05E9",
  "second": "\u05E9\u05E0\u05D9\u05D9\u05D4",
  "selectedDateDescription": args => "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E0\u05D1\u05D7\u05E8: ".concat(args.date),
  "selectedRangeDescription": args => "\u05D8\u05D5\u05D5\u05D7 \u05E0\u05D1\u05D7\u05E8: ".concat(args.startDate, " \u05E2\u05D3 ").concat(args.endDate),
  "selectedTimeDescription": args => "\u05D6\u05DE\u05DF \u05E0\u05D1\u05D7\u05E8: ".concat(args.time),
  "startDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05EA\u05D7\u05DC\u05D4",
  "timeZoneName": "\u05D0\u05D6\u05D5\u05E8 \u05D6\u05DE\u05DF",
  "weekday": "\u05D9\u05D5\u05DD \u05D1\u05E9\u05D1\u05D5\u05E2",
  "year": "\u05E9\u05E0\u05D4"
};
var $7297908fac4cf6c2$exports = {};
$7297908fac4cf6c2$exports = {
  "calendar": "Kalendar",
  "day": "dan",
  "dayPeriod": "AM/PM",
  "endDate": "Datum zavr\u0161etka",
  "era": "era",
  "hour": "sat",
  "minute": "minuta",
  "month": "mjesec",
  "second": "sekunda",
  "selectedDateDescription": args => "Odabrani datum: ".concat(args.date),
  "selectedRangeDescription": args => "Odabrani raspon: ".concat(args.startDate, " do ").concat(args.endDate),
  "selectedTimeDescription": args => "Odabrano vrijeme: ".concat(args.time),
  "startDate": "Datum po\u010Detka",
  "timeZoneName": "vremenska zona",
  "weekday": "dan u tjednu",
  "year": "godina"
};
var $f95c1b06e1d5ba32$exports = {};
$f95c1b06e1d5ba32$exports = {
  "calendar": "Napt\xE1r",
  "day": "nap",
  "dayPeriod": "napszak",
  "endDate": "Befejez\u0151 d\xE1tum",
  "era": "\xE9ra",
  "hour": "\xF3ra",
  "minute": "perc",
  "month": "h\xF3nap",
  "second": "m\xE1sodperc",
  "selectedDateDescription": args => "Kijel\xF6lt d\xE1tum: ".concat(args.date),
  "selectedRangeDescription": args => "Kijel\xF6lt tartom\xE1ny: ".concat(args.startDate, "\u2013").concat(args.endDate),
  "selectedTimeDescription": args => "Kijel\xF6lt id\u0151: ".concat(args.time),
  "startDate": "Kezd\u0151 d\xE1tum",
  "timeZoneName": "id\u0151z\xF3na",
  "weekday": "h\xE9t napja",
  "year": "\xE9v"
};
var $437a8dc519258a01$exports = {};
$437a8dc519258a01$exports = {
  "calendar": "Calendario",
  "day": "giorno",
  "dayPeriod": "AM/PM",
  "endDate": "Data finale",
  "era": "era",
  "hour": "ora",
  "minute": "minuto",
  "month": "mese",
  "second": "secondo",
  "selectedDateDescription": args => "Data selezionata: ".concat(args.date),
  "selectedRangeDescription": args => "Intervallo selezionato: da ".concat(args.startDate, " a ").concat(args.endDate),
  "selectedTimeDescription": args => "Ora selezionata: ".concat(args.time),
  "startDate": "Data iniziale",
  "timeZoneName": "fuso orario",
  "weekday": "giorno della settimana",
  "year": "anno"
};
var $bd0aa2b50092a836$exports = {};
$bd0aa2b50092a836$exports = {
  "calendar": "\u30AB\u30EC\u30F3\u30C0\u30FC",
  "day": "\u65E5",
  "dayPeriod": "\u5348\u524D/\u5348\u5F8C",
  "endDate": "\u7D42\u4E86\u65E5",
  "era": "\u6642\u4EE3",
  "hour": "\u6642",
  "minute": "\u5206",
  "month": "\u6708",
  "second": "\u79D2",
  "selectedDateDescription": args => "\u9078\u629E\u3057\u305F\u65E5\u4ED8 : ".concat(args.date),
  "selectedRangeDescription": args => "\u9078\u629E\u7BC4\u56F2 : ".concat(args.startDate, " \u304B\u3089 ").concat(args.endDate),
  "selectedTimeDescription": args => "\u9078\u629E\u3057\u305F\u6642\u9593 : ".concat(args.time),
  "startDate": "\u958B\u59CB\u65E5",
  "timeZoneName": "\u30BF\u30A4\u30E0\u30BE\u30FC\u30F3",
  "weekday": "\u66DC\u65E5",
  "year": "\u5E74"
};
var $bbd8176c2e044bc1$exports = {};
$bbd8176c2e044bc1$exports = {
  "calendar": "\uB2EC\uB825",
  "day": "\uC77C",
  "dayPeriod": "\uC624\uC804/\uC624\uD6C4",
  "endDate": "\uC885\uB8CC \uB0A0\uC9DC",
  "era": "\uC5F0\uD638",
  "hour": "\uC2DC",
  "minute": "\uBD84",
  "month": "\uC6D4",
  "second": "\uCD08",
  "selectedDateDescription": args => "\uC120\uD0DD \uC77C\uC790: ".concat(args.date),
  "selectedRangeDescription": args => "\uC120\uD0DD \uBC94\uC704: ".concat(args.startDate, " ~ ").concat(args.endDate),
  "selectedTimeDescription": args => "\uC120\uD0DD \uC2DC\uAC04: ".concat(args.time),
  "startDate": "\uC2DC\uC791 \uB0A0\uC9DC",
  "timeZoneName": "\uC2DC\uAC04\uB300",
  "weekday": "\uC694\uC77C",
  "year": "\uB144"
};
var $1af703df56ff5180$exports = {};
$1af703df56ff5180$exports = {
  "calendar": "Kalendorius",
  "day": "diena",
  "dayPeriod": "iki piet\u0173 / po piet\u0173",
  "endDate": "Pabaigos data",
  "era": "era",
  "hour": "valanda",
  "minute": "minut\u0117",
  "month": "m\u0117nuo",
  "second": "sekund\u0117",
  "selectedDateDescription": args => "Pasirinkta data: ".concat(args.date),
  "selectedRangeDescription": args => "Pasirinktas intervalas: nuo ".concat(args.startDate, " iki ").concat(args.endDate),
  "selectedTimeDescription": args => "Pasirinktas laikas: ".concat(args.time),
  "startDate": "Prad\u017Eios data",
  "timeZoneName": "laiko juosta",
  "weekday": "savait\u0117s diena",
  "year": "metai"
};
var $9705eb4511dea9f8$exports = {};
$9705eb4511dea9f8$exports = {
  "calendar": "Kalend\u0101rs",
  "day": "diena",
  "dayPeriod": "priek\u0161pusdien\u0101/p\u0113cpusdien\u0101",
  "endDate": "Beigu datums",
  "era": "\u0113ra",
  "hour": "stundas",
  "minute": "min\u016Btes",
  "month": "m\u0113nesis",
  "second": "sekundes",
  "selectedDateDescription": args => "Atlas\u012Btais datums: ".concat(args.date),
  "selectedRangeDescription": args => "Atlas\u012Btais diapazons: no ".concat(args.startDate, " l\u012Bdz ").concat(args.endDate),
  "selectedTimeDescription": args => "Atlas\u012Btais laiks: ".concat(args.time),
  "startDate": "S\u0101kuma datums",
  "timeZoneName": "laika josla",
  "weekday": "ned\u0113\u013Cas diena",
  "year": "gads"
};
var $8ef984876a7160bc$exports = {};
$8ef984876a7160bc$exports = {
  "calendar": "Kalender",
  "day": "dag",
  "dayPeriod": "a.m./p.m.",
  "endDate": "Sluttdato",
  "era": "tidsalder",
  "hour": "time",
  "minute": "minutt",
  "month": "m\xE5ned",
  "second": "sekund",
  "selectedDateDescription": args => "Valgt dato: ".concat(args.date),
  "selectedRangeDescription": args => "Valgt omr\xE5de: ".concat(args.startDate, " til ").concat(args.endDate),
  "selectedTimeDescription": args => "Valgt tid: ".concat(args.time),
  "startDate": "Startdato",
  "timeZoneName": "tidssone",
  "weekday": "ukedag",
  "year": "\xE5r"
};
var $b6e9809e1ecaa25e$exports = {};
$b6e9809e1ecaa25e$exports = {
  "calendar": "Kalender",
  "day": "dag",
  "dayPeriod": "a.m./p.m.",
  "endDate": "Einddatum",
  "era": "tijdperk",
  "hour": "uur",
  "minute": "minuut",
  "month": "maand",
  "second": "seconde",
  "selectedDateDescription": args => "Geselecteerde datum: ".concat(args.date),
  "selectedRangeDescription": args => "Geselecteerd bereik: ".concat(args.startDate, " tot ").concat(args.endDate),
  "selectedTimeDescription": args => "Geselecteerde tijd: ".concat(args.time),
  "startDate": "Startdatum",
  "timeZoneName": "tijdzone",
  "weekday": "dag van de week",
  "year": "jaar"
};
var $deb2fa609661fe31$exports = {};
$deb2fa609661fe31$exports = {
  "calendar": "Kalendarz",
  "day": "dzie\u0144",
  "dayPeriod": "rano / po po\u0142udniu / wieczorem",
  "endDate": "Data ko\u0144cowa",
  "era": "era",
  "hour": "godzina",
  "minute": "minuta",
  "month": "miesi\u0105c",
  "second": "sekunda",
  "selectedDateDescription": args => "Wybrana data: ".concat(args.date),
  "selectedRangeDescription": args => "Wybrany zakres: ".concat(args.startDate, " do ").concat(args.endDate),
  "selectedTimeDescription": args => "Wybrany czas: ".concat(args.time),
  "startDate": "Data pocz\u0105tkowa",
  "timeZoneName": "strefa czasowa",
  "weekday": "dzie\u0144 tygodnia",
  "year": "rok"
};
var $591c8c054c84fa56$exports = {};
$591c8c054c84fa56$exports = {
  "calendar": "Calend\xE1rio",
  "day": "dia",
  "dayPeriod": "AM/PM",
  "endDate": "Data final",
  "era": "era",
  "hour": "hora",
  "minute": "minuto",
  "month": "m\xEAs",
  "second": "segundo",
  "selectedDateDescription": args => "Data selecionada: ".concat(args.date),
  "selectedRangeDescription": args => "Intervalo selecionado: ".concat(args.startDate, " a ").concat(args.endDate),
  "selectedTimeDescription": args => "Hora selecionada: ".concat(args.time),
  "startDate": "Data inicial",
  "timeZoneName": "fuso hor\xE1rio",
  "weekday": "dia da semana",
  "year": "ano"
};
var $f1633bd6cbc228e8$exports = {};
$f1633bd6cbc228e8$exports = {
  "calendar": "Calend\xE1rio",
  "day": "dia",
  "dayPeriod": "am/pm",
  "endDate": "Data de T\xE9rmino",
  "era": "era",
  "hour": "hora",
  "minute": "minuto",
  "month": "m\xEAs",
  "second": "segundo",
  "selectedDateDescription": args => "Data selecionada: ".concat(args.date),
  "selectedRangeDescription": args => "Intervalo selecionado: ".concat(args.startDate, " a ").concat(args.endDate),
  "selectedTimeDescription": args => "Hora selecionada: ".concat(args.time),
  "startDate": "Data de In\xEDcio",
  "timeZoneName": "fuso hor\xE1rio",
  "weekday": "dia da semana",
  "year": "ano"
};
var $14e09da03f3d1c5b$exports = {};
$14e09da03f3d1c5b$exports = {
  "calendar": "Calendar",
  "day": "zi",
  "dayPeriod": "a.m/p.m.",
  "endDate": "Dat\u0103 final",
  "era": "er\u0103",
  "hour": "or\u0103",
  "minute": "minut",
  "month": "lun\u0103",
  "second": "secund\u0103",
  "selectedDateDescription": args => "Dat\u0103 selectat\u0103: ".concat(args.date),
  "selectedRangeDescription": args => "Interval selectat: de la ".concat(args.startDate, " p\xE2n\u0103 la ").concat(args.endDate),
  "selectedTimeDescription": args => "Ora selectat\u0103: ".concat(args.time),
  "startDate": "Dat\u0103 \xEEnceput",
  "timeZoneName": "fus orar",
  "weekday": "ziua din s\u0103pt\u0103m\xE2n\u0103",
  "year": "an"
};
var $63247a3456bc40d1$exports = {};
$63247a3456bc40d1$exports = {
  "calendar": "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C",
  "day": "\u0434\u0435\u043D\u044C",
  "dayPeriod": "AM/PM",
  "endDate": "\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F",
  "era": "\u044D\u0440\u0430",
  "hour": "\u0447\u0430\u0441",
  "minute": "\u043C\u0438\u043D\u0443\u0442\u0430",
  "month": "\u043C\u0435\u0441\u044F\u0446",
  "second": "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
  "selectedDateDescription": args => "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430: ".concat(args.date),
  "selectedRangeDescription": args => "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: \u0441 ".concat(args.startDate, " \u043F\u043E ").concat(args.endDate),
  "selectedTimeDescription": args => "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F: ".concat(args.time),
  "startDate": "\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430",
  "timeZoneName": "\u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u043F\u043E\u044F\u0441",
  "weekday": "\u0434\u0435\u043D\u044C \u043D\u0435\u0434\u0435\u043B\u0438",
  "year": "\u0433\u043E\u0434"
};
var $22150dd20c353dd4$exports = {};
$22150dd20c353dd4$exports = {
  "calendar": "Kalend\xE1r",
  "day": "de\u0148",
  "dayPeriod": "AM/PM",
  "endDate": "D\xE1tum ukon\u010Denia",
  "era": "letopo\u010Det",
  "hour": "hodina",
  "minute": "min\xFAta",
  "month": "mesiac",
  "second": "sekunda",
  "selectedDateDescription": args => "Vybrat\xFD d\xE1tum: ".concat(args.date),
  "selectedRangeDescription": args => "Vybrat\xFD rozsah: od ".concat(args.startDate, " do ").concat(args.endDate),
  "selectedTimeDescription": args => "Vybrat\xFD \u010Das: ".concat(args.time),
  "startDate": "D\xE1tum za\u010Datia",
  "timeZoneName": "\u010Dasov\xE9 p\xE1smo",
  "weekday": "de\u0148 t\xFD\u017Ed\u0148a",
  "year": "rok"
};
var $701eb9a0385c55fd$exports = {};
$701eb9a0385c55fd$exports = {
  "calendar": "Koledar",
  "day": "dan",
  "dayPeriod": "dop/pop",
  "endDate": "Datum konca",
  "era": "doba",
  "hour": "ura",
  "minute": "minuta",
  "month": "mesec",
  "second": "sekunda",
  "selectedDateDescription": args => "Izbrani datum: ".concat(args.date),
  "selectedRangeDescription": args => "Izbrano obmo\u010Dje: ".concat(args.startDate, " do ").concat(args.endDate),
  "selectedTimeDescription": args => "Izbrani \u010Das: ".concat(args.time),
  "startDate": "Datum za\u010Detka",
  "timeZoneName": "\u010Dasovni pas",
  "weekday": "dan v tednu",
  "year": "leto"
};
var $54684a4891ca6dc5$exports = {};
$54684a4891ca6dc5$exports = {
  "calendar": "Kalendar",
  "day": "\u0434\u0430\u043D",
  "dayPeriod": "\u043F\u0440\u0435 \u043F\u043E\u0434\u043D\u0435/\u043F\u043E \u043F\u043E\u0434\u043D\u0435",
  "endDate": "Datum zavr\u0161etka",
  "era": "\u0435\u0440\u0430",
  "hour": "\u0441\u0430\u0442",
  "minute": "\u043C\u0438\u043D\u0443\u0442",
  "month": "\u043C\u0435\u0441\u0435\u0446",
  "second": "\u0441\u0435\u043A\u0443\u043D\u0434",
  "selectedDateDescription": args => "Izabrani datum: ".concat(args.date),
  "selectedRangeDescription": args => "Izabrani opseg: od ".concat(args.startDate, " do ").concat(args.endDate),
  "selectedTimeDescription": args => "Izabrano vreme: ".concat(args.time),
  "startDate": "Datum po\u010Detka",
  "timeZoneName": "\u0432\u0440\u0435\u043C\u0435\u043D\u0441\u043A\u0430 \u0437\u043E\u043D\u0430",
  "weekday": "\u0434\u0430\u043D \u0443 \u043D\u0435\u0434\u0435\u0459\u0438",
  "year": "\u0433\u043E\u0434\u0438\u043D\u0430"
};
var $545887f88a5a52db$exports = {};
$545887f88a5a52db$exports = {
  "calendar": "Kalender",
  "day": "dag",
  "dayPeriod": "fm/em",
  "endDate": "Slutdatum",
  "era": "era",
  "hour": "timme",
  "minute": "minut",
  "month": "m\xE5nad",
  "second": "sekund",
  "selectedDateDescription": args => "Valt datum: ".concat(args.date),
  "selectedRangeDescription": args => "Valt intervall: ".concat(args.startDate, " till ").concat(args.endDate),
  "selectedTimeDescription": args => "Vald tid: ".concat(args.time),
  "startDate": "Startdatum",
  "timeZoneName": "tidszon",
  "weekday": "veckodag",
  "year": "\xE5r"
};
var $492d49420dd96ff4$exports = {};
$492d49420dd96ff4$exports = {
  "calendar": "Takvim",
  "day": "g\xFCn",
  "dayPeriod": "\xD6\xD6/\xD6S",
  "endDate": "Biti\u015F Tarihi",
  "era": "\xE7a\u011F",
  "hour": "saat",
  "minute": "dakika",
  "month": "ay",
  "second": "saniye",
  "selectedDateDescription": args => "Se\xE7ilen Tarih: ".concat(args.date),
  "selectedRangeDescription": args => "Se\xE7ilen Aral\u0131k: ".concat(args.startDate, " - ").concat(args.endDate),
  "selectedTimeDescription": args => "Se\xE7ilen Zaman: ".concat(args.time),
  "startDate": "Ba\u015Flang\u0131\xE7 Tarihi",
  "timeZoneName": "saat dilimi",
  "weekday": "haftan\u0131n g\xFCn\xFC",
  "year": "y\u0131l"
};
var $dc85765e85e8f267$exports = {};
$dc85765e85e8f267$exports = {
  "calendar": "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440",
  "day": "\u0434\u0435\u043D\u044C",
  "dayPeriod": "\u0434\u043F/\u043F\u043F",
  "endDate": "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
  "era": "\u0435\u0440\u0430",
  "hour": "\u0433\u043E\u0434\u0438\u043D\u0430",
  "minute": "\u0445\u0432\u0438\u043B\u0438\u043D\u0430",
  "month": "\u043C\u0456\u0441\u044F\u0446\u044C",
  "second": "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
  "selectedDateDescription": args => "\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date),
  "selectedRangeDescription": args => "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.startDate, " \u2014 ").concat(args.endDate),
  "selectedTimeDescription": args => "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0447\u0430\u0441: ".concat(args.time),
  "startDate": "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
  "timeZoneName": "\u0447\u0430\u0441\u043E\u0432\u0438\u0439 \u043F\u043E\u044F\u0441",
  "weekday": "\u0434\u0435\u043D\u044C \u0442\u0438\u0436\u043D\u044F",
  "year": "\u0440\u0456\u043A"
};
var $2157d63cb80c7c63$exports = {};
$2157d63cb80c7c63$exports = {
  "calendar": "\u65E5\u5386",
  "day": "\u65E5",
  "dayPeriod": "\u4E0A\u5348/\u4E0B\u5348",
  "endDate": "\u7ED3\u675F\u65E5\u671F",
  "era": "\u7EAA\u5143",
  "hour": "\u5C0F\u65F6",
  "minute": "\u5206\u949F",
  "month": "\u6708",
  "second": "\u79D2",
  "selectedDateDescription": args => "\u9009\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date),
  "selectedRangeDescription": args => "\u9009\u5B9A\u7684\u8303\u56F4\uFF1A".concat(args.startDate, " \u81F3 ").concat(args.endDate),
  "selectedTimeDescription": args => "\u9009\u5B9A\u7684\u65F6\u95F4\uFF1A".concat(args.time),
  "startDate": "\u5F00\u59CB\u65E5\u671F",
  "timeZoneName": "\u65F6\u533A",
  "weekday": "\u5DE5\u4F5C\u65E5",
  "year": "\u5E74"
};
var $0335c3ddb5f70cbe$exports = {};
$0335c3ddb5f70cbe$exports = {
  "calendar": "\u65E5\u66C6",
  "day": "\u65E5",
  "dayPeriod": "\u4E0A\u5348/\u4E0B\u5348",
  "endDate": "\u7D50\u675F\u65E5\u671F",
  "era": "\u7EAA\u5143",
  "hour": "\u5C0F\u65F6",
  "minute": "\u5206\u949F",
  "month": "\u6708",
  "second": "\u79D2",
  "selectedDateDescription": args => "\u9078\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date),
  "selectedRangeDescription": args => "\u9078\u5B9A\u7684\u7BC4\u570D\uFF1A".concat(args.startDate, " \u81F3 ").concat(args.endDate),
  "selectedTimeDescription": args => "\u9078\u5B9A\u7684\u6642\u9593\uFF1A".concat(args.time),
  "startDate": "\u958B\u59CB\u65E5\u671F",
  "timeZoneName": "\u65F6\u533A",
  "weekday": "\u5DE5\u4F5C\u65E5",
  "year": "\u5E74"
};
$c1905b78f6d2f5bf$exports = {
  "ar-AE": $aa344be62785b256$exports,
  "bg-BG": $615986c3475e7c8c$exports,
  "cs-CZ": $6c6207692f1ab248$exports,
  "da-DK": $fb37a9d024dd70f8$exports,
  "de-DE": $d7780bd4790f7ae9$exports,
  "el-GR": $9cdf03311f06c4ac$exports,
  "en-US": $f93fc9e164ae811c$exports,
  "es-ES": $7426c3264bf5ffea$exports,
  "et-EE": $1115cc0042de790c$exports,
  "fi-FI": $4e80389dccb9283f$exports,
  "fr-FR": $78ad6f738c1f38d1$exports,
  "he-IL": $50fa4716d827cd97$exports,
  "hr-HR": $7297908fac4cf6c2$exports,
  "hu-HU": $f95c1b06e1d5ba32$exports,
  "it-IT": $437a8dc519258a01$exports,
  "ja-JP": $bd0aa2b50092a836$exports,
  "ko-KR": $bbd8176c2e044bc1$exports,
  "lt-LT": $1af703df56ff5180$exports,
  "lv-LV": $9705eb4511dea9f8$exports,
  "nb-NO": $8ef984876a7160bc$exports,
  "nl-NL": $b6e9809e1ecaa25e$exports,
  "pl-PL": $deb2fa609661fe31$exports,
  "pt-BR": $591c8c054c84fa56$exports,
  "pt-PT": $f1633bd6cbc228e8$exports,
  "ro-RO": $14e09da03f3d1c5b$exports,
  "ru-RU": $63247a3456bc40d1$exports,
  "sk-SK": $22150dd20c353dd4$exports,
  "sl-SI": $701eb9a0385c55fd$exports,
  "sr-SP": $54684a4891ca6dc5$exports,
  "sv-SE": $545887f88a5a52db$exports,
  "tr-TR": $492d49420dd96ff4$exports,
  "uk-UA": $dc85765e85e8f267$exports,
  "zh-CN": $2157d63cb80c7c63$exports,
  "zh-TW": $0335c3ddb5f70cbe$exports
};

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $715562ad3b4cced4$export$4a931266a3838b86(state, ref, disableArrowNavigation) {
  let {
    direction: direction
  } = (0, $IwcIq$reactariai18n.useLocale)();
  let focusManager = (0, $IwcIq$react.useMemo)(() => (0, $IwcIq$reactariafocus.createFocusManager)(ref), [ref]);
  // Open the popover on alt + arrow down
  let onKeyDown = e => {
    if (!e.currentTarget.contains(e.target)) return;
    if (e.altKey && (e.key === "ArrowDown" || e.key === "ArrowUp") && "setOpen" in state) {
      e.preventDefault();
      e.stopPropagation();
      state.setOpen(true);
    }
    if (disableArrowNavigation) return;
    switch (e.key) {
      case "ArrowLeft":
        e.preventDefault();
        e.stopPropagation();
        if (direction === "rtl") focusManager.focusNext();else focusManager.focusPrevious();
        break;
      case "ArrowRight":
        e.preventDefault();
        e.stopPropagation();
        if (direction === "rtl") focusManager.focusPrevious();else focusManager.focusNext();
        break;
    }
  };
  // Focus the first placeholder segment from the end on mouse down/touch up in the field.
  let focusLast = () => {
    var _window_event;
    // Try to find the segment prior to the element that was clicked on.
    let target = (_window_event = window.event) === null || _window_event === void 0 ? void 0 : _window_event.target;
    let walker = (0, $IwcIq$reactariafocus.getFocusableTreeWalker)(ref.current, {
      tabbable: true
    });
    if (target) {
      walker.currentNode = target;
      target = walker.previousNode();
    }
    // If no target found, find the last element from the end.
    if (!target) {
      let last;
      do {
        last = walker.lastChild();
        if (last) target = last;
      } while (last);
    }
    // Now go backwards until we find an element that is not a placeholder.
    while (target === null || target === void 0 ? void 0 : target.hasAttribute("data-placeholder")) {
      let prev = walker.previousNode();
      if (prev && prev.hasAttribute("data-placeholder")) target = prev;else break;
    }
    if (target) target.focus();
  };
  let {
    pressProps: pressProps
  } = (0, $IwcIq$reactariainteractions.usePress)({
    preventFocusOnPress: true,
    allowTextSelectionOnPress: true,
    onPressStart(e) {
      if (e.pointerType === "mouse") focusLast();
    },
    onPress(e) {
      if (e.pointerType !== "mouse") focusLast();
    }
  });
  return (0, $IwcIq$reactariautils.mergeProps)(pressProps, {
    onKeyDown: onKeyDown
  });
}
const $4acc2f407c169e55$export$653eddfc964b0f8a = new WeakMap();
const $4acc2f407c169e55$export$300019f83c56d282 = "__role_" + Date.now();
const $4acc2f407c169e55$export$7b3062cd49e80452 = "__focusManager_" + Date.now();
function $4acc2f407c169e55$export$5591b0b878c1a989(props, state, ref) {
  var _state_value;
  let {
    labelProps: labelProps,
    fieldProps: fieldProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  } = (0, $IwcIq$reactarialabel.useField)({
    ...props,
    labelElementType: "span"
  });
  let {
    focusWithinProps: focusWithinProps
  } = (0, $IwcIq$reactariainteractions.useFocusWithin)({
    ...props,
    onBlurWithin: e => {
      state.confirmPlaceholder();
      if (props.onBlur) props.onBlur(e);
    },
    onFocusWithin: props.onFocus,
    onFocusWithinChange: props.onFocusChange
  });
  let stringFormatter = (0, $IwcIq$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($c1905b78f6d2f5bf$exports)));
  let message = state.maxGranularity === "hour" ? "selectedTimeDescription" : "selectedDateDescription";
  let field = state.maxGranularity === "hour" ? "time" : "date";
  let description = state.value ? stringFormatter.format(message, {
    [field]: state.formatValue({
      month: "long"
    })
  }) : "";
  let descProps = (0, $IwcIq$reactariautils.useDescription)(description);
  // If within a date picker or date range picker, the date field will have role="presentation" and an aria-describedby
  // will be passed in that references the value (e.g. entire range). Otherwise, add the field's value description.
  let describedBy = props[$4acc2f407c169e55$export$300019f83c56d282] === "presentation" ? fieldProps["aria-describedby"] : [descProps["aria-describedby"], fieldProps["aria-describedby"]].filter(Boolean).join(" ") || undefined;
  let propsFocusManager = props[$4acc2f407c169e55$export$7b3062cd49e80452];
  let focusManager = (0, $IwcIq$react.useMemo)(() => propsFocusManager || (0, $IwcIq$reactariafocus.createFocusManager)(ref), [propsFocusManager, ref]);
  let groupProps = (0, $715562ad3b4cced4$export$4a931266a3838b86)(state, ref, props[$4acc2f407c169e55$export$300019f83c56d282] === "presentation");
  // Pass labels and other information to segments.
  $4acc2f407c169e55$export$653eddfc964b0f8a.set(state, {
    ariaLabel: props["aria-label"],
    ariaLabelledBy: [labelProps.id, props["aria-labelledby"]].filter(Boolean).join(" ") || undefined,
    ariaDescribedBy: describedBy,
    focusManager: focusManager
  });
  let autoFocusRef = (0, $IwcIq$react.useRef)(props.autoFocus);
  // When used within a date picker or date range picker, the field gets role="presentation"
  // rather than role="group". Since the date picker/date range picker already has a role="group"
  // with a label and description, and the segments are already labeled by this as well, this
  // avoids very verbose duplicate announcements.
  let fieldDOMProps;
  if (props[$4acc2f407c169e55$export$300019f83c56d282] === "presentation") fieldDOMProps = {
    role: "presentation"
  };else fieldDOMProps = (0, $IwcIq$reactariautils.mergeProps)(fieldProps, {
    role: "group",
    "aria-disabled": props.isDisabled || undefined,
    "aria-describedby": describedBy
  });
  (0, $IwcIq$react.useEffect)(() => {
    if (autoFocusRef.current) focusManager.focusFirst();
    autoFocusRef.current = false;
  }, [focusManager]);
  (0, $IwcIq$reactariautils.useFormReset)(props.inputRef, state.value, state.setValue);
  let domProps = (0, $IwcIq$reactariautils.filterDOMProps)(props);
  return {
    labelProps: {
      ...labelProps,
      onClick: () => {
        focusManager.focusFirst();
      }
    },
    fieldProps: (0, $IwcIq$reactariautils.mergeProps)(domProps, fieldDOMProps, groupProps, focusWithinProps, {
      onKeyDown(e) {
        if (props.onKeyDown) props.onKeyDown(e);
      },
      onKeyUp(e) {
        if (props.onKeyUp) props.onKeyUp(e);
      }
    }),
    inputProps: {
      type: "hidden",
      name: props.name,
      value: ((_state_value = state.value) === null || _state_value === void 0 ? void 0 : _state_value.toString()) || ""
    },
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  };
}
function $4acc2f407c169e55$export$4c842f6a241dc825(props, state, ref) {
  var _state_timeValue;
  let res = $4acc2f407c169e55$export$5591b0b878c1a989(props, state, ref);
  res.inputProps.value = ((_state_timeValue = state.timeValue) === null || _state_timeValue === void 0 ? void 0 : _state_timeValue.toString()) || "";
  return res;
}
function $e90ae7c26a69c6b1$export$42df105a73306d51(props, state, ref) {
  let buttonId = (0, $IwcIq$reactariautils.useId)();
  let dialogId = (0, $IwcIq$reactariautils.useId)();
  let fieldId = (0, $IwcIq$reactariautils.useId)();
  let stringFormatter = (0, $IwcIq$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($c1905b78f6d2f5bf$exports)));
  let {
    labelProps: labelProps,
    fieldProps: fieldProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  } = (0, $IwcIq$reactarialabel.useField)({
    ...props,
    labelElementType: "span"
  });
  let groupProps = (0, $715562ad3b4cced4$export$4a931266a3838b86)(state, ref);
  let labelledBy = fieldProps["aria-labelledby"] || fieldProps.id;
  let {
    locale: locale
  } = (0, $IwcIq$reactariai18n.useLocale)();
  let date = state.formatValue(locale, {
    month: "long"
  });
  let description = date ? stringFormatter.format("selectedDateDescription", {
    date: date
  }) : "";
  let descProps = (0, $IwcIq$reactariautils.useDescription)(description);
  let ariaDescribedBy = [descProps["aria-describedby"], fieldProps["aria-describedby"]].filter(Boolean).join(" ") || undefined;
  let domProps = (0, $IwcIq$reactariautils.filterDOMProps)(props);
  let focusManager = (0, $IwcIq$react.useMemo)(() => (0, $IwcIq$reactariafocus.createFocusManager)(ref), [ref]);
  let {
    focusWithinProps: focusWithinProps
  } = (0, $IwcIq$reactariainteractions.useFocusWithin)({
    ...props,
    isDisabled: state.isOpen,
    onBlurWithin: props.onBlur,
    onFocusWithin: props.onFocus,
    onFocusWithinChange: props.onFocusChange
  });
  return {
    groupProps: (0, $IwcIq$reactariautils.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
      role: "group",
      "aria-disabled": props.isDisabled || null,
      "aria-labelledby": labelledBy,
      "aria-describedby": ariaDescribedBy,
      onKeyDown(e) {
        if (state.isOpen) return;
        if (props.onKeyDown) props.onKeyDown(e);
      },
      onKeyUp(e) {
        if (state.isOpen) return;
        if (props.onKeyUp) props.onKeyUp(e);
      }
    }),
    labelProps: {
      ...labelProps,
      onClick: () => {
        focusManager.focusFirst();
      }
    },
    fieldProps: {
      ...fieldProps,
      id: fieldId,
      [(0, $4acc2f407c169e55$export$300019f83c56d282)]: "presentation",
      "aria-describedby": ariaDescribedBy,
      value: state.value,
      onChange: state.setValue,
      minValue: props.minValue,
      maxValue: props.maxValue,
      placeholderValue: props.placeholderValue,
      hideTimeZone: props.hideTimeZone,
      hourCycle: props.hourCycle,
      shouldForceLeadingZeros: props.shouldForceLeadingZeros,
      granularity: props.granularity,
      isDisabled: props.isDisabled,
      isReadOnly: props.isReadOnly,
      isRequired: props.isRequired,
      isInvalid: state.isInvalid,
      autoFocus: props.autoFocus,
      name: props.name
    },
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    buttonProps: {
      ...descProps,
      id: buttonId,
      "aria-haspopup": "dialog",
      "aria-label": stringFormatter.format("calendar"),
      "aria-labelledby": "".concat(buttonId, " ").concat(labelledBy),
      "aria-describedby": ariaDescribedBy,
      "aria-expanded": state.isOpen || undefined,
      onPress: () => state.setOpen(true)
    },
    dialogProps: {
      id: dialogId,
      "aria-labelledby": "".concat(buttonId, " ").concat(labelledBy)
    },
    calendarProps: {
      autoFocus: true,
      value: state.dateValue,
      onChange: state.setDateValue,
      minValue: props.minValue,
      maxValue: props.maxValue,
      isDisabled: props.isDisabled,
      isReadOnly: props.isReadOnly,
      isDateUnavailable: props.isDateUnavailable,
      defaultFocusedValue: state.dateValue ? undefined : props.placeholderValue,
      isInvalid: state.isInvalid,
      errorMessage: props.errorMessage
    }
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore

function $934ac650a0aceb4b$export$d42c60378c8168f8() {
  let {
    locale: locale
  } = (0, $IwcIq$reactariai18n.useLocale)();
  return (0, $IwcIq$react.useMemo)(() => {
    // Try to use Intl.DisplayNames if possible. It may be supported in browsers, but not support the dateTimeField
    // type as that was only added in v2. https://github.com/tc39/intl-displaynames-v2
    try {
      // @ts-ignore
      return new Intl.DisplayNames(locale, {
        type: "dateTimeField"
      });
    } catch (err) {
      return new $934ac650a0aceb4b$var$DisplayNamesPolyfill(locale);
    }
  }, [locale]);
}
class $934ac650a0aceb4b$var$DisplayNamesPolyfill {
  of(field) {
    return this.dictionary.getStringForLocale(field, this.locale);
  }
  constructor(locale) {
    this.locale = locale;
    this.dictionary = new (0, $IwcIq$internationalizedstring.LocalizedStringDictionary)((0, /*@__PURE__*/$parcel$interopDefault($c1905b78f6d2f5bf$exports)));
  }
}
function $5c015c6316d1904d$export$1315d136e6f7581(segment, state, ref) {
  let enteredKeys = (0, $IwcIq$react.useRef)("");
  let {
    locale: locale
  } = (0, $IwcIq$reactariai18n.useLocale)();
  let displayNames = (0, $934ac650a0aceb4b$export$d42c60378c8168f8)();
  let {
    ariaLabel: ariaLabel,
    ariaLabelledBy: ariaLabelledBy,
    ariaDescribedBy: ariaDescribedBy,
    focusManager: focusManager
  } = (0, $4acc2f407c169e55$export$653eddfc964b0f8a).get(state);
  let textValue = segment.isPlaceholder ? "" : segment.text;
  let options = (0, $IwcIq$react.useMemo)(() => state.dateFormatter.resolvedOptions(), [state.dateFormatter]);
  let monthDateFormatter = (0, $IwcIq$reactariai18n.useDateFormatter)({
    month: "long",
    timeZone: options.timeZone
  });
  let hourDateFormatter = (0, $IwcIq$reactariai18n.useDateFormatter)({
    hour: "numeric",
    hour12: options.hour12,
    timeZone: options.timeZone
  });
  if (segment.type === "month" && !segment.isPlaceholder) {
    let monthTextValue = monthDateFormatter.format(state.dateValue);
    textValue = monthTextValue !== textValue ? "".concat(textValue, " \u2013 ").concat(monthTextValue) : monthTextValue;
  } else if (segment.type === "hour" && !segment.isPlaceholder) textValue = hourDateFormatter.format(state.dateValue);
  let {
    spinButtonProps: spinButtonProps
  } = (0, $IwcIq$reactariaspinbutton.useSpinButton)({
    // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
    // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
    // https://github.com/dequelabs/axe-core/issues/3505
    value: segment.value,
    textValue: textValue,
    minValue: segment.minValue,
    maxValue: segment.maxValue,
    isDisabled: state.isDisabled,
    isReadOnly: state.isReadOnly || !segment.isEditable,
    isRequired: state.isRequired,
    onIncrement: () => {
      enteredKeys.current = "";
      state.increment(segment.type);
    },
    onDecrement: () => {
      enteredKeys.current = "";
      state.decrement(segment.type);
    },
    onIncrementPage: () => {
      enteredKeys.current = "";
      state.incrementPage(segment.type);
    },
    onDecrementPage: () => {
      enteredKeys.current = "";
      state.decrementPage(segment.type);
    },
    onIncrementToMax: () => {
      enteredKeys.current = "";
      state.setSegment(segment.type, segment.maxValue);
    },
    onDecrementToMin: () => {
      enteredKeys.current = "";
      state.setSegment(segment.type, segment.minValue);
    }
  });
  let parser = (0, $IwcIq$react.useMemo)(() => new (0, $IwcIq$internationalizednumber.NumberParser)(locale, {
    maximumFractionDigits: 0
  }), [locale]);
  let backspace = () => {
    if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly && !segment.isPlaceholder) {
      let newValue = segment.text.slice(0, -1);
      let parsed = parser.parse(newValue);
      if (newValue.length === 0 || parsed === 0) state.clearSegment(segment.type);else state.setSegment(segment.type, parsed);
      enteredKeys.current = newValue;
    } else if (segment.type === "dayPeriod") state.clearSegment(segment.type);
  };
  let onKeyDown = e => {
    // Firefox does not fire selectstart for Ctrl/Cmd + A
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1742153
    if (e.key === "a" && ((0, $IwcIq$reactariautils.isMac)() ? e.metaKey : e.ctrlKey)) e.preventDefault();
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    switch (e.key) {
      case "Backspace":
      case "Delete":
        // Safari on iOS does not fire beforeinput for the backspace key because the cursor is at the start.
        e.preventDefault();
        e.stopPropagation();
        backspace();
        break;
    }
  };
  // Safari dayPeriod option doesn't work...
  let {
    startsWith: startsWith
  } = (0, $IwcIq$reactariai18n.useFilter)({
    sensitivity: "base"
  });
  let amPmFormatter = (0, $IwcIq$reactariai18n.useDateFormatter)({
    hour: "numeric",
    hour12: true
  });
  let am = (0, $IwcIq$react.useMemo)(() => {
    let date = new Date();
    date.setHours(0);
    return amPmFormatter.formatToParts(date).find(part => part.type === "dayPeriod").value;
  }, [amPmFormatter]);
  let pm = (0, $IwcIq$react.useMemo)(() => {
    let date = new Date();
    date.setHours(12);
    return amPmFormatter.formatToParts(date).find(part => part.type === "dayPeriod").value;
  }, [amPmFormatter]);
  // Get a list of formatted era names so users can type the first character to choose one.
  let eraFormatter = (0, $IwcIq$reactariai18n.useDateFormatter)({
    year: "numeric",
    era: "narrow",
    timeZone: "UTC"
  });
  let eras = (0, $IwcIq$react.useMemo)(() => {
    if (segment.type !== "era") return [];
    let date = (0, $IwcIq$internationalizeddate.toCalendar)(new (0, $IwcIq$internationalizeddate.CalendarDate)(1, 1, 1), state.calendar);
    let eras = state.calendar.getEras().map(era => {
      let eraDate = date.set({
        year: 1,
        month: 1,
        day: 1,
        era: era
      }).toDate("UTC");
      let parts = eraFormatter.formatToParts(eraDate);
      let formatted = parts.find(p => p.type === "era").value;
      return {
        era: era,
        formatted: formatted
      };
    });
    // Remove the common prefix from formatted values. This is so that in calendars with eras like
    // ERA0 and ERA1 (e.g. Ethiopic), users can press "0" and "1" to select an era. In other cases,
    // the first letter is used.
    let prefixLength = $5c015c6316d1904d$var$commonPrefixLength(eras.map(era => era.formatted));
    if (prefixLength) for (let era of eras) era.formatted = era.formatted.slice(prefixLength);
    return eras;
  }, [eraFormatter, state.calendar, segment.type]);
  let onInput = key => {
    if (state.isDisabled || state.isReadOnly) return;
    let newValue = enteredKeys.current + key;
    switch (segment.type) {
      case "dayPeriod":
        if (startsWith(am, key)) state.setSegment("dayPeriod", 0);else if (startsWith(pm, key)) state.setSegment("dayPeriod", 12);else break;
        focusManager.focusNext();
        break;
      case "era":
        {
          let matched = eras.find(e => startsWith(e.formatted, key));
          if (matched) {
            state.setSegment("era", matched.era);
            focusManager.focusNext();
          }
          break;
        }
      case "day":
      case "hour":
      case "minute":
      case "second":
      case "month":
      case "year":
        {
          if (!parser.isValidPartialNumber(newValue)) return;
          let numberValue = parser.parse(newValue);
          let segmentValue = numberValue;
          let allowsZero = segment.minValue === 0;
          if (segment.type === "hour" && state.dateFormatter.resolvedOptions().hour12) {
            switch (state.dateFormatter.resolvedOptions().hourCycle) {
              case "h11":
                if (numberValue > 11) segmentValue = parser.parse(key);
                break;
              case "h12":
                allowsZero = false;
                if (numberValue > 12) segmentValue = parser.parse(key);
                break;
            }
            if (segment.value >= 12 && numberValue > 1) numberValue += 12;
          } else if (numberValue > segment.maxValue) segmentValue = parser.parse(key);
          if (isNaN(numberValue)) return;
          let shouldSetValue = segmentValue !== 0 || allowsZero;
          if (shouldSetValue) state.setSegment(segment.type, segmentValue);
          if (Number(numberValue + "0") > segment.maxValue || newValue.length >= String(segment.maxValue).length) {
            enteredKeys.current = "";
            if (shouldSetValue) focusManager.focusNext();
          } else enteredKeys.current = newValue;
          break;
        }
    }
  };
  let onFocus = () => {
    enteredKeys.current = "";
    (0, $IwcIq$reactariautils.scrollIntoViewport)(ref.current, {
      containingElement: (0, $IwcIq$reactariautils.getScrollParent)(ref.current)
    });
    // Collapse selection to start or Chrome won't fire input events.
    let selection = window.getSelection();
    selection.collapse(ref.current);
  };
  let compositionRef = (0, $IwcIq$react.useRef)("");
  // @ts-ignore - TODO: possibly old TS version? doesn't fail in my editor...
  (0, $IwcIq$reactariautils.useEvent)(ref, "beforeinput", e => {
    e.preventDefault();
    switch (e.inputType) {
      case "deleteContentBackward":
      case "deleteContentForward":
        if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly) backspace();
        break;
      case "insertCompositionText":
        // insertCompositionText cannot be canceled.
        // Record the current state of the element so we can restore it in the `input` event below.
        compositionRef.current = ref.current.textContent;
        // Safari gets stuck in a composition state unless we also assign to the value here.
        // eslint-disable-next-line no-self-assign
        ref.current.textContent = ref.current.textContent;
        break;
      default:
        if (e.data != null) onInput(e.data);
        break;
    }
  });
  (0, $IwcIq$reactariautils.useEvent)(ref, "input", e => {
    let {
      inputType: inputType,
      data: data
    } = e;
    switch (inputType) {
      case "insertCompositionText":
        // Reset the DOM to how it was in the beforeinput event.
        ref.current.textContent = compositionRef.current;
        // Android sometimes fires key presses of letters as composition events. Need to handle am/pm keys here too.
        // Can also happen e.g. with Pinyin keyboard on iOS.
        if (startsWith(am, data) || startsWith(pm, data)) onInput(data);
        break;
    }
  });
  (0, $IwcIq$reactariautils.useLayoutEffect)(() => {
    let element = ref.current;
    return () => {
      // If the focused segment is removed, focus the previous one, or the next one if there was no previous one.
      if (document.activeElement === element) {
        let prev = focusManager.focusPrevious();
        if (!prev) focusManager.focusNext();
      }
    };
  }, [ref, focusManager]);
  // spinbuttons cannot be focused with VoiceOver on iOS.
  let touchPropOverrides = (0, $IwcIq$reactariautils.isIOS)() || segment.type === "timeZoneName" ? {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuetext": null,
    "aria-valuenow": null
  } : {};
  // Only apply aria-describedby to the first segment, unless the field is invalid. This avoids it being
  // read every time the user navigates to a new segment.
  let firstSegment = (0, $IwcIq$react.useMemo)(() => state.segments.find(s => s.isEditable), [state.segments]);
  if (segment !== firstSegment && !state.isInvalid) ariaDescribedBy = undefined;
  let id = (0, $IwcIq$reactariautils.useId)();
  let isEditable = !state.isDisabled && !state.isReadOnly && segment.isEditable;
  // Prepend the label passed from the field to each segment name.
  // This is needed because VoiceOver on iOS does not announce groups.
  let name = segment.type === "literal" ? "" : displayNames.of(segment.type);
  let labelProps = (0, $IwcIq$reactariautils.useLabels)({
    "aria-label": "".concat(name).concat(ariaLabel ? ", ".concat(ariaLabel) : "").concat(ariaLabelledBy ? ", " : ""),
    "aria-labelledby": ariaLabelledBy
  });
  // Literal segments should not be visible to screen readers. We don't really need any of the above,
  // but the rules of hooks mean hooks cannot be conditional so we have to put this condition here.
  if (segment.type === "literal") return {
    segmentProps: {
      "aria-hidden": true
    }
  };
  return {
    segmentProps: (0, $IwcIq$reactariautils.mergeProps)(spinButtonProps, labelProps, {
      id: id,
      ...touchPropOverrides,
      "aria-invalid": state.isInvalid ? "true" : undefined,
      "aria-describedby": ariaDescribedBy,
      "aria-readonly": state.isReadOnly || !segment.isEditable ? "true" : undefined,
      "data-placeholder": segment.isPlaceholder || undefined,
      contentEditable: isEditable,
      suppressContentEditableWarning: isEditable,
      spellCheck: isEditable ? "false" : undefined,
      autoCapitalize: isEditable ? "off" : undefined,
      autoCorrect: isEditable ? "off" : undefined,
      // Capitalization was changed in React 17...
      [parseInt((0, $parcel$interopDefault($IwcIq$react)).version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: isEditable ? "next" : undefined,
      inputMode: state.isDisabled || segment.type === "dayPeriod" || segment.type === "era" || !isEditable ? undefined : "numeric",
      tabIndex: state.isDisabled ? undefined : 0,
      onKeyDown: onKeyDown,
      onFocus: onFocus,
      style: {
        caretColor: "transparent"
      },
      // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
      onPointerDown(e) {
        e.stopPropagation();
      },
      onMouseDown(e) {
        e.stopPropagation();
      }
    })
  };
}
function $5c015c6316d1904d$var$commonPrefixLength(strings) {
  // Sort the strings, and compare the characters in the first and last to find the common prefix.
  strings.sort();
  let first = strings[0];
  let last = strings[strings.length - 1];
  for (let i = 0; i < first.length; i++) {
    if (first[i] !== last[i]) return i;
  }
  return 0;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $20f695b1b69e6b9e$export$12fd5f0e9f4bb192(props, state, ref) {
  var _state_value, _state_value1;
  let stringFormatter = (0, $IwcIq$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($c1905b78f6d2f5bf$exports)));
  let {
    labelProps: labelProps,
    fieldProps: fieldProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  } = (0, $IwcIq$reactarialabel.useField)({
    ...props,
    labelElementType: "span"
  });
  let labelledBy = fieldProps["aria-labelledby"] || fieldProps.id;
  let {
    locale: locale
  } = (0, $IwcIq$reactariai18n.useLocale)();
  let range = state.formatValue(locale, {
    month: "long"
  });
  let description = range ? stringFormatter.format("selectedRangeDescription", {
    startDate: range.start,
    endDate: range.end
  }) : "";
  let descProps = (0, $IwcIq$reactariautils.useDescription)(description);
  let startFieldProps = {
    "aria-label": stringFormatter.format("startDate"),
    "aria-labelledby": labelledBy
  };
  let endFieldProps = {
    "aria-label": stringFormatter.format("endDate"),
    "aria-labelledby": labelledBy
  };
  let buttonId = (0, $IwcIq$reactariautils.useId)();
  let dialogId = (0, $IwcIq$reactariautils.useId)();
  let groupProps = (0, $715562ad3b4cced4$export$4a931266a3838b86)(state, ref);
  let ariaDescribedBy = [descProps["aria-describedby"], fieldProps["aria-describedby"]].filter(Boolean).join(" ") || undefined;
  let focusManager = (0, $IwcIq$react.useMemo)(() => (0, $IwcIq$reactariafocus.createFocusManager)(ref, {
    // Exclude the button from the focus manager.
    accept: element => element.id !== buttonId
  }), [ref, buttonId]);
  let commonFieldProps = {
    [(0, $4acc2f407c169e55$export$7b3062cd49e80452)]: focusManager,
    [(0, $4acc2f407c169e55$export$300019f83c56d282)]: "presentation",
    "aria-describedby": ariaDescribedBy,
    minValue: props.minValue,
    maxValue: props.maxValue,
    placeholderValue: props.placeholderValue,
    hideTimeZone: props.hideTimeZone,
    hourCycle: props.hourCycle,
    granularity: props.granularity,
    shouldForceLeadingZeros: props.shouldForceLeadingZeros,
    isDisabled: props.isDisabled,
    isReadOnly: props.isReadOnly,
    isRequired: props.isRequired,
    isInvalid: state.isInvalid
  };
  let domProps = (0, $IwcIq$reactariautils.filterDOMProps)(props);
  let {
    focusWithinProps: focusWithinProps
  } = (0, $IwcIq$reactariainteractions.useFocusWithin)({
    ...props,
    isDisabled: state.isOpen,
    onBlurWithin: props.onBlur,
    onFocusWithin: props.onFocus,
    onFocusWithinChange: props.onFocusChange
  });
  return {
    groupProps: (0, $IwcIq$reactariautils.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
      role: "group",
      "aria-disabled": props.isDisabled || null,
      "aria-describedby": ariaDescribedBy,
      onKeyDown(e) {
        if (state.isOpen) return;
        if (props.onKeyDown) props.onKeyDown(e);
      },
      onKeyUp(e) {
        if (state.isOpen) return;
        if (props.onKeyUp) props.onKeyUp(e);
      }
    }),
    labelProps: {
      ...labelProps,
      onClick: () => {
        focusManager.focusFirst();
      }
    },
    buttonProps: {
      ...descProps,
      id: buttonId,
      "aria-haspopup": "dialog",
      "aria-label": stringFormatter.format("calendar"),
      "aria-labelledby": "".concat(buttonId, " ").concat(labelledBy),
      "aria-describedby": ariaDescribedBy,
      "aria-expanded": state.isOpen || undefined,
      onPress: () => state.setOpen(true)
    },
    dialogProps: {
      id: dialogId,
      "aria-labelledby": "".concat(buttonId, " ").concat(labelledBy)
    },
    startFieldProps: {
      ...startFieldProps,
      ...commonFieldProps,
      value: (_state_value = state.value) === null || _state_value === void 0 ? void 0 : _state_value.start,
      onChange: start => state.setDateTime("start", start),
      autoFocus: props.autoFocus,
      name: props.startName
    },
    endFieldProps: {
      ...endFieldProps,
      ...commonFieldProps,
      value: (_state_value1 = state.value) === null || _state_value1 === void 0 ? void 0 : _state_value1.end,
      onChange: end => state.setDateTime("end", end),
      name: props.endName
    },
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    calendarProps: {
      autoFocus: true,
      value: state.dateRange,
      onChange: state.setDateRange,
      minValue: props.minValue,
      maxValue: props.maxValue,
      isDisabled: props.isDisabled,
      isReadOnly: props.isReadOnly,
      isDateUnavailable: props.isDateUnavailable,
      allowsNonContiguousRanges: props.allowsNonContiguousRanges,
      defaultFocusedValue: state.dateRange ? undefined : props.placeholderValue,
      isInvalid: state.isInvalid,
      errorMessage: props.errorMessage
    }
  };
}